/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Header_Usp_Items1Inputs */

const vi_sitesettings_header_usp_items1 = /** @type {(inputs: Sitesettings_Header_Usp_Items1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dải ưu điểm trên cùng (máy tính)`)
};

/**

* @param {Sitesettings_Header_Usp_Items1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_header_usp_items1 = /** @type {((inputs?: Sitesettings_Header_Usp_Items1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Header_Usp_Items1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_header_usp_items1(inputs)
});
export { sitesettings_header_usp_items1 as "siteSettings_header_usp_items" }